import styled from "styled-components";

// List

export const CardTitleStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: auto;
  height: 90% !important;
`;
export const ListItemStyled = styled.li`
  display: flex;
  border-bottom: 1px solid #eeeeee;
`;
export const ListItemHeaderStyled = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  align-items: center;
  font-size: 12px;
  width: 100%;
  margin-bottom: 0.3rem;
`;
export const TitleContainerStyled = styled.div`
  margin: 0 0.2rem;
`;
export const ListItemTitleStyled = styled.h6`
  display: flex;
  /* background-color: greenyellow; */
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
  margin: 0;
  margin-bottom: 0.25rem;
  margin-left: ${(props) => (props.left ? `${props.left}rem` : "0")};
`;
export const LineStyled = styled.hr`
  width: 100%;
  border: 0;
  height: 1px;
  margin: 0.2rem 0;
  background-image: linear-gradient(
    to right,
    rgba(196, 196, 196, 0.1),
    rgba(196, 196, 196, 0.75),
    rgba(196, 196, 196, 0.1)
  );
`;
export const QuantityStyled = styled.span`
  margin-left: 0.2rem;
`;
export const NameStyled = styled.span`
  margin-left: 0.4rem;
  text-align: start;
`;

export const ColumnStyled = styled.div`
  padding: 3px;
  text-align: center;

  flex-direction: ${(props) => (props.dir ? `${props.dir}` : "row")};
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  font-size: 12px;
  /* width: 25%; */
  width: ${(props) => (props.width ? `${props.width}%` : "10%")};
  word-wrap: break-all;
  display: flex;
  align-items: center;
  color: #3c4858;
`;
